import { Grid } from '@mui/material'
import { TFunction } from 'next-i18next'
import React from 'react'

const Descriptions = (props: Props) => {
	const { t } = props;
	
  const press_info = [
		{
			title: t('describe-h3'),
			description: t('describe-p'),
		},
		{
			title: t('founded-h4'),
			description: t('founded-p'),
		},
		{
			title: t('shortdesc-h4'),
			description: t('shortdesc-p'),
		},
		{
			title: t('boilerplate-h4'),
			description: t('boilerplate-p1'),
		},
		{
			description: t('boilerplate-p2'),
		},
		{
			description: t('boilerplate-p3'),
		},
  ]
  
  return (
    <Grid item xs={12} md={8}>
      {
        press_info?.map(info => (
          <div key={info.title} style={{textAlign: 'left'}}>
            <h3>{info.title}</h3>
            <p dangerouslySetInnerHTML={{ __html: info.description }} />
          </div>
        ))
      }
    </Grid>
  )
}

interface Props {
	t: TFunction
}

export default Descriptions
